import ky from "ky";

// Delegated rather than bound per button: a slider that loops with few slides
// duplicates its cards after this script has run, and those copies would carry a
// button that does nothing. Delegation also means a card rendered later -- load
// more, an editor preview -- needs no wiring of its own.
document.addEventListener(
    "click",
    async function (event) {
        const button = event.target.closest("[data-favorite-button]");
        if (!button) return;

        const postID = button.dataset.postId;
        if (!postID) return;

        const iconElement = button.querySelector("iconify-icon");
        const originalIconHTML = iconElement ? iconElement.outerHTML : "";

        if (iconElement) {
            iconElement.outerHTML = '<iconify-icon class="iconify icon-spin" icon="fas:spinner"></iconify-icon>';
        }

        const action = button.dataset.action;

        if (action === "add") {
            await handleFavorite("add_to_favorites", postID, button, true, originalIconHTML);
        } else if (action === "remove") {
            await handleFavorite("remove_from_favorites", postID, button, false, originalIconHTML);
        }
    },
    { passive: true },
);

// The same post can be on the page more than once: twice in a looping slider, or in
// two blocks at once. They all show the same state, so they all get updated.
function buttonsForPost(postID) {
    return document.querySelectorAll(`[data-favorite-button][data-post-id="${CSS.escape(postID)}"]`);
}

async function handleFavorite(action, postID, button, isAdding, originalIconHTML) {
    const formData = new FormData();
    formData.append("action", action);
    formData.append("security", frameworkGlobal.nonce);
    formData.append("post_id", postID);

    try {
        const response = await ky.post(frameworkGlobal.ajaxurl, { body: formData }).json();

        if (response.success) {
            const icon = isAdding
                ? frameworkGlobal.wpsoup.favorites.button_icon_favorited
                : frameworkGlobal.wpsoup.favorites.button_icon_unfavorited;

            buttonsForPost(postID).forEach((favoriteButton) => {
                favoriteButton.classList.toggle("is-favorited", isAdding);

                const favoriteIcon = favoriteButton.querySelector("iconify-icon");
                if (favoriteIcon) favoriteIcon.outerHTML = icon;

                favoriteButton.dataset.action = isAdding ? "remove" : "add";
            });

            const customEvent = new CustomEvent("favoriteToggled", {
                detail: {
                    postId: postID,
                    button: button,
                    response: response,
                    isAdding: isAdding,
                },
                bubbles: false,
                cancelable: false,
            });

            button.dispatchEvent(customEvent);
            document.dispatchEvent(customEvent);
        } else {
            restoreIcon(button, originalIconHTML);
        }
    } catch (error) {
        restoreIcon(button, originalIconHTML);
    }
}

function restoreIcon(button, originalIconHTML) {
    const icon = button.querySelector("iconify-icon");
    if (icon) icon.outerHTML = originalIconHTML;
}
